// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PaperClipOutlinedSvg from "@ant-design/icons-svg/es/asn/PaperClipOutlined";
import AntdIcon from '../components/AntdIcon';

var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PaperClipOutlinedSvg
  }));
};

PaperClipOutlined.displayName = 'PaperClipOutlined';
export default React.forwardRef(PaperClipOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PaperClipOutlined.js
// module id = 1535
// module chunks = 0